/* eslint-disable max-len */

import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import AbstractToolboxItem from './AbstractToolboxItem';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * Web implementation of {@code AbstractToolboxItem}.
 */
class ToolboxItem extends AbstractToolboxItem {
  /**
   * Initializes a new {@code ToolboxItem} instance.
   *
   * @inheritdoc
   */
  constructor(props) {
    super(props);

    this._onKeyPress = this._onKeyPress.bind(this);
  }

  /**
   * Handles 'Enter' and Space key on the button to trigger onClick for accessibility.
   *
   * @param {Object} event - The key event.
   * @private
   * @returns {void}
   */
  _onKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.props.onClick();
    }
  }

  /**
   * Handles rendering of the actual item. If the label is being shown, which
   * is controlled with the `showLabel` prop, the item is rendered for its
   * display in an overflow menu, otherwise it will only have an icon, which
   * can be displayed on any toolbar.
   *
   * @protected
   * @returns {ReactElement}
   */
  _renderItem() {
    const { disabled, onClick, tooltipPosition, toggled } = this.props;
    const props = {
      'aria-pressed': toggled,
      'aria-disabled': disabled,
      'aria-label': this.accessibilityLabel,
      className: `toggle-button${disabled ? ' disabled' : ''}`,
      onClick: disabled ? undefined : onClick,
      onKeyPress: this._onKeyPress,
      tabIndex: 0,
      role: 'button'
    };

    const useTooltip = this.tooltip && this.tooltip.length > 0;
    const children = <Switch checked={!toggled} {...props} />;

    if (useTooltip) {
      return (
        <Tooltip content={this.tooltip} position={tooltipPosition}>
          {children}
        </Tooltip>
      );
    }

    return children;
  }
}
export default React.memo(withBoundary(ToolboxItem));
